import { useQueryClient } from "@tanstack/react-query";
import { useDomainMutation } from "@/modules/common/hooks/domain-mutation.hook";
import { Track } from "../../types";
import { unarchiveTrack } from "../../api";
import { AxiosResponse } from "axios";

export function useUnarchiveTrack() {
  const queryClient = useQueryClient();

  const mutation = useDomainMutation<
    AxiosResponse<Track>,
    { response?: { data?: { message?: string } } },
    { uid: string }
  >({
    mutationFn: ({ uid }: { uid: string }) => {
      return unarchiveTrack(uid);
    },
    allowWhenReadonly: true,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["track"] });
    },
  });

  return mutation;
}
